import { __decorate } from "tslib";
import { html, nothing } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { property } from 'lit/decorators.js';
import styles from './callout.scss.js';
/**
 * cipublic-callout
 *
 * @slot heading
 * @slot content
 */
export class Callout extends CipublicElement {
    constructor() {
        super(...arguments);
        /**
         * The type of Callout.
         */
        this.variant = 'full-width';
        this.background = 'primary';
        this.iconVariant = 'primary';
    }
    getIconVariant() {
        if (this.background === 'primary') {
            this.iconVariant = 'primary';
        }
    }
    render() {
        if (this.variant === 'quotation') {
            return html `${this.getIconVariant()}<figure class="callout-${this.variant} callout-background-${this.background}-${this.iconVariant}"><span class="icon-wrapper"><slot name="icon"></slot></span><div class="callout-wrapper"><div class="content-wrapper"><blockquote class="blockquote"><slot name="heading"></slot></blockquote><figcaption class="figcaption"><slot name="content"></slot></figcaption></div></div></figure>`;
        }
        else {
            return html `${this.getIconVariant()}<div class="callout-${this.variant} callout-background-${this.background}-${this.iconVariant}"><div class="icon-wrapper"><slot name="icon"></slot></div><div class="callout-wrapper"><div class="content-wrapper">${this.variant !== 'skinny' ? html `<slot name="heading" class="heading"></slot>` : nothing} <span class="${this.variant}-content"><slot name="content"></slot></span><slot name="additionalContent"></slot></div></div></div>`;
        }
    }
}
Callout.styles = styles;
__decorate([
    property({ reflect: true })
], Callout.prototype, "variant", void 0);
__decorate([
    property({ reflect: true })
], Callout.prototype, "background", void 0);
__decorate([
    property({ reflect: true })
], Callout.prototype, "iconVariant", void 0);
__decorate([
    property({ reflect: true })
], Callout.prototype, "iconLabel", void 0);
//# sourceMappingURL=callout.js.map